<div class="main-container">
    <div class="poblacion-content row">
        <span style="font-size: large;">
            Ingrese la información del usuario a consultar
        </span>
        <span style="font-size: medium; color: var(--mid-gray-color);">
            Recuerde que puede hacer la búsqueda por tipo y número de documento, por número de contrato o por ambos.
        </span>
        <br><br>
        <form [formGroup]="frmPoblacion">
            <div class="form-container row">
                <div class="row col-lg-6 col-md-8 col-xs-12">
                    <div class="col-12 col-lg-6">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Tipo de Identificación</mat-label>
                            <mat-select name="docItem" formControlName="documentType">
                                @for (docItem of documentTypeData; track docItem) {
                                <mat-option [value]="docItem.acronym">{{ docItem.acronym }} - {{
                                    docItem.name}}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="hasError( getControl['documentType'] )">
                                {{ printError( getControl['documentType'] , {} ) }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-6">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Número de Identificación</mat-label>
                            <input matInput type="text" formControlName="documentNumber" maxlength="30"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                            <mat-error *ngIf="hasError( getControl['documentNumber'] )">
                                {{ printError( getControl['documentNumber'], {'noSpaces':'No se permite espacios'} ) }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-6">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Número Contrato</mat-label>
                            <input matInput type="text" formControlName="contractNumber" maxlength="8"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                            <mat-error *ngIf="hasError( getControl['contractNumber'] )">
                                {{ printError( getControl['contractNumber'] ,{} ) }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row col-lg-6 col-md-4 col-xs-12">
                    <div class="col-12 col-lg-5">
                        <button type="submit" class="btn btn-primary btn-icon" (click)="consultar()" appTrackClick
                            [trackData]="{
                            module: 'Mi población',
                            category: 'N/A',
                            submodule: 'Consulta mis usuarios población',
                            functionality: 'Consultar',
                            identificadorInteraccion: 'POB_CONSULTA_USU_POB_CONSULTAR',
                        }">
                            <mat-icon>search</mat-icon><span>CONSULTAR</span>
                        </button>
                    </div>
                    <div class="col-12 col-lg-5">
                        <button class="btn btn-primary btn-icon" (click)="clear()">
                            <mat-icon>cancel</mat-icon><span>LIMPIAR</span>
                        </button>
                        
                    </div>
                    <div class="col-12 col-lg-5">
                        <button *ngIf="dsPoblacion && dsPoblacion.length > 0" type="button"
                        class="btn btn-primary btn-icon w-100 mt-2" (click)="openCertificadosModal()">
                        <mat-icon>description</mat-icon><span>GENERAR CERTIFICADOS</span>
                    </button>
                    </div>
                    
                </div>
            </div>
        </form>
        <div *ngIf="haveResponde">
            <div *ngIf="haveDate">
                <h1><b>Detalle de contratos</b></h1>
                <mat-card class="main-card" *ngFor="let poblationCard of dsPoblacion">
                    <div class="card-header-poblacion">
                        <div class="card-title-container">
                            <mat-card-title class="card-title"><b>Contrato # {{ poblationCard.contrato
                                    }}</b></mat-card-title>
                            <mat-card-title class="card-subtitle">Contratante: {{ poblationCard.nombre
                                }}</mat-card-title>
                            <mat-card-title class="card-subtitle">{{ poblationCard.programa }}</mat-card-title>
                            <mat-card-title class="card-subtitle">{{ poblationCard.cuenta }}</mat-card-title>
                        </div>
                        <div class="card-button-container row">
                            <button class="btn btn-action btn-bill btn-icon" (click)="generateBill(poblationCard)"
                                appTrackClick [trackData]="{
                                module: 'Mi población',
                                category: 'N/A',
                                submodule: 'Consulta mis usuarios población',
                                functionality: 'Generar factura',
                                identificadorInteraccion: 'POB_CONSULTA_USU_POB_GENERAR_FACTURA',
                            }">
                                <mat-icon svgIcon="poblacion_bill"></mat-icon><span
                                    style="width: calc(80% - 24px);">GENERAR FACTURA</span>
                            </button>
                            <button class="btn btn-action btn-link-pago btn-icon" (click)="linkPago(poblationCard)"
                                appTrackClick [trackData]="{
                                module: 'Mi población',
                                category: 'N/A',
                                submodule: 'Consulta mis usuarios población',
                                functionality: 'Link pago (cuota mes)',
                                identificadorInteraccion: 'POB_CONSULTA_USU_POB_LINKPAGO',
                            }">
                                <mat-icon svgIcon="poblacion_link"></mat-icon><span
                                    style="width: calc(80% - 24px);">LINK PAGO</span>
                            </button>
                        </div>
                    </div>
                    <div class="card-body-poblacion">
                        <div class="card-body-item" style="position: relative;"
                            *ngFor="let beneficiario of poblationCard.beneficiarios">
                            <mat-card-content class="card-body-data-container">
                                <div class="card-body-info">
                                    <div class="card-body-info-text">
                                        <div class="card-body-data-text"><mat-icon class="card-body-data-icon"
                                                svgIcon="poblacion_doc"></mat-icon><span
                                                style="margin-left: 0.5rem;">{{beneficiario.identificacion}}</span>
                                        </div>
                                        <div class="card-body-data-text"><mat-icon class="card-body-data-icon"
                                                svgIcon="poblacion_person"></mat-icon><span
                                                style="margin-left: 0.5rem;">{{ beneficiario.nombre }}</span></div>
                                        <div class="card-body-data-text"><mat-icon class="card-body-data-icon"
                                                svgIcon="poblacion_doc"></mat-icon><span style="margin-left: 0.5rem;">{{
                                                beneficiario.estado }}</span></div>
                                        <div class="card-body-data-text"><mat-icon class="card-body-data-icon"
                                                svgIcon="poblacion_person"></mat-icon><span
                                                style="margin-left: 0.5rem;">{{ beneficiario.parentesco }}</span></div>
                                        <div class="card-body-data-text"><mat-icon class="card-body-data-icon"
                                                svgIcon="poblacion_tel"></mat-icon><span style="margin-left: 0.5rem;">{{
                                                beneficiario.celular }}</span></div>
                                    </div>
                                    <div class="card-body-info-icon">
                                        <mat-icon class="card-body-icon" svgIcon="poblacion_search"
                                            (click)="seeDetails(beneficiario, poblationCard.contrato)"></mat-icon>
                                    </div>
                                </div>
                                <div class="card-body-button-container row">
                                    <button class="btn btn-action btn-generate btn-icon"
                                        (click)="generateCarnet(beneficiario, poblationCard.contrato)" appTrackClick
                                        [trackData]="{
                                        module: 'Mi población',
                                        category: 'N/A',
                                        submodule: 'Consulta mis usuarios población',
                                        functionality: 'Generar carnet',
                                        identificadorInteraccion: 'POB_CONSULTA_USU_POB_GENERAR_CARNET',
                                    }">
                                        <mat-icon svgIcon="poblacion_carnet"></mat-icon><span
                                            style="width: calc(80% - 24px);">GENERAR CARNET</span>
                                    </button>
                                    <button class="btn btn-action btn-consult btn-icon"
                                        (click)="consultDirectory(beneficiario)" appTrackClick [trackData]="{
                                            module: 'Mi población',
                                            category: 'N/A',
                                            submodule: 'Consulta mis usuarios población',
                                            functionality: 'Consultar directorio',
                                            identificadorInteraccion: 'POB_CONSULTA_USU_POB_CONSULTAR_DIRECTORIO',
                                        }">
                                        <div class="d-flex justify-content-center">
                                            <mat-icon svgIcon="poblacion_directorio"
                                                style="margin: 2px;"></mat-icon><span
                                                style="width: calc(80% - 24px); margin: 2px;">CONSULTAR
                                                DIRECTORIO</span>
                                        </div>
                                    </button>
                                    <button class="btn btn-action btn-reside btn-icon"
                                        (click)="radicar_solicitud(beneficiario, poblationCard.contrato, poblationCard.lineaDeNegocio)"
                                        appTrackClick [trackData]="{
                                        module: 'Mi población',
                                        category: 'N/A',
                                        submodule: 'Consulta mis usuarios población',
                                        functionality: 'Radicar solicitud autorización',
                                        identificadorInteraccion: 'POB_CONSULTA_USU_POB_RADICAR_AUTORIZACION',
                                    }">
                                        <div class="d-flex justify-content-center">
                                            <mat-icon class="icono-blanco" svgIcon="poblacion_reside"
                                                style="margin: 2px;"></mat-icon><span
                                                style="width: calc(80% - 24px); margin: 2px;">RADICAR SOLICITUD</span>
                                        </div>
                                    </button>
                                </div>
                            </mat-card-content>
                        </div>
                    </div>
                </mat-card>
            </div>

            <div style="text-align: center;" class="" *ngIf="!haveDate">
                <div>
                    <img style="width: 16rem;" src="assets/imagenes/no-dta.webp">
                </div>
                <br>
                <span class="message-span">{{ generalMessage.toUpperCase() }}</span>
            </div>
        </div>
        <div *ngIf="!haveResponde" class="message-container">
            <span class="message-span">{{ generalMessage.toUpperCase() }}</span>
        </div>
    </div>
</div>
a